export const SET_LOADING = "BUSSINESS_STEP/SET_LOADING";
export const SET_BUSINESSES = "BUSSINESS_STEP/SET_BUSINESSES";
export const SET_SUB_CATEGORIES = "CATEGORIES/SET_SUB_CATEGORIES";
